module.exports = __webpack_public_path__ + "x1.no2.738555d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/x1.no2.jpg
// module id = 8Nh3
// module chunks = 0